<template>
  <div>
    <b-modal id="modalTurboModeDynamicShaping" ref="modalTurboModeDynamicShaping" :title="$t('Turbo mode')" hide-footer size="lg" @shown="shown">
      <div>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editTurboMode.name"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('One-time service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editTurboMode.once_service_id" :options="oneServices"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Incoming')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editTurboMode.incoming_rate" :disabled="incomingUnlimited"/>
          <b-checkbox v-model="incomingUnlimited">{{ $t('Unlimited') }}</b-checkbox>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Outgoing')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editTurboMode.outgoing_rate" :disabled="outgoingUnlimited"/>
          <b-checkbox v-model="outgoingUnlimited">{{ $t('Unlimited') }}</b-checkbox>
        </b-form-group>
        <b-form-radio v-model="selected" value="durationRadio" name="some-radios">{{ $t('Duration') }}</b-form-radio>
        <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4" :disabled="selected === 'trafficValumeRadio'">
          <label>{{ $t('Days') }}</label>
          <b-form-spinbutton v-model="days" vertical wrap min="0" max="31" :disabled="editTurboMode.till_acct_period_end != 0"/>
          <label>{{ $t('Hours') }}</label>
          <b-form-spinbutton v-model="hours" vertical wrap min="0" max="23" :disabled="editTurboMode.till_acct_period_end != 0"/>
          <label>{{ $t('Minutes') }}</label>
          <b-form-spinbutton v-model="minutes" vertical wrap min="0" max="59" :disabled="editTurboMode.till_acct_period_end != 0"/>
          <b-checkbox v-model="editTurboMode.till_acct_period_end" value="1" unchecked-value="0">{{ $t('Until the end of accounting period') }}</b-checkbox>
        </b-form-group>
        <b-form-radio v-model="selected" value="trafficValumeRadio" name="some-radios">{{ $t('Traffic valume') }}</b-form-radio>
        <b-form-group label-cols="4" label-cols-xl="4" label-cols-md="4" :disabled="selected === 'durationRadio'">
          <b-form-group label-align="right" :label="$t('Incoming')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editTurboMode.incoming_limit"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Outgoing')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="editTurboMode.outgoing_limit"/>
          </b-form-group>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTurboModeDynamicShaping.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editTurboMode: null,
    turboModeItems: null
  },
  data () {
    return {
      oneServices: [],
      selected: 'durationRadio',
      incomingUnlimited: false,
      outgoingUnlimited: false,
      days: 0,
      hours: 0,
      minutes: 0
    }
  },
  methods: {
    save () {
      if (this.editTurboMode.once_service_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Choose one-time service'), 'Error')
        return
      }
      if (this.selected === 'trafficValumeRadio') {
        if (Number(this.editTurboMode.incoming_limit) === 0 || Number(this.editTurboMode.outgoing_limit) === 0) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Traffic valume Incoming or Outgoing fields is invalid'), 'Error')
          return
        }
      }

      this.editTurboMode.till_acct_period_end = Number(this.editTurboMode.till_acct_period_end)
      if (this.incomingUnlimited) {
        this.editTurboMode.incoming_rate = '-1'
      }
      if (this.outgoingUnlimited) {
        this.editTurboMode.outgoing_rate = '-1'
      }
      if (this.selected === 'trafficValumeRadio') {
        this.editTurboMode.till_acct_period_end = 0
        this.editTurboMode.duration = 0
        this.editTurboMode.incoming_limit = Number(this.editTurboMode.incoming_limit)
        this.editTurboMode.outgoing_limit = Number(this.editTurboMode.outgoing_limit)
      } else {
        this.editTurboMode.incoming_limit = 0
        this.editTurboMode.outgoing_limit = 0
        if (this.editTurboMode.till_acct_period_end === 1) {
          this.editTurboMode.duration = 0
        } else {
          this.editTurboMode.duration = this.days * 86400 + this.hours * 3600 + this.minutes * 60
        }
      }

      if (this.editTurboMode.incoming_limit || this.editTurboMode.outgoing_limit) {
        if (this.editTurboMode.incoming_limit && this.editTurboMode.outgoing_limit) {
          this.editTurboMode.work = this.editTurboMode.incoming_limit + 'B/' + this.editTurboMode.outgoing_limit + 'B'
        } else if (this.editTurboMode.incoming_limit) {
          this.editTurboMode.work = this.editTurboMode.incoming_limit + 'B/' + this.$i18n.t('not set')
        } else if (this.editTurboMode.outgoing_limit) {
          this.editTurboMode.work = this.$i18n.t('not set') + '/' + this.editTurboMode.outgoing_limit + 'B'
        }
      } else {
        if (this.editTurboMode.till_acct_period_end) {
          this.editTurboMode.work = this.$i18n.t('until aggregation period end')
        } else {
          this.editTurboMode.work = this.days + this.$i18n.t('d. ') + this.hours + this.$i18n.t('h. ') + this.minutes + this.$i18n.t('m.')
        }
      }
      let speedIncoming = this.editTurboMode.incoming_rate
      let speedOutgoing = this.editTurboMode.outgoing_rate
      if (speedIncoming === '0' || speedIncoming === '') {
        speedIncoming = this.$i18n.t('Disabled')
      } else if (speedIncoming === '-1') {
        speedIncoming = this.$i18n.t('Unlimited')
      }
      if (speedOutgoing === '0' || speedOutgoing === '') {
        speedOutgoing = this.$i18n.t('Disabled')
      } else if (speedOutgoing === '-1') {
        speedOutgoing = this.$i18n.t('Unlimited')
      }
      this.editTurboMode.speed = speedIncoming + '/' + speedOutgoing

      for (let el of this.oneServices) {
        if (el.value === this.editTurboMode.once_service_id) {
          this.editTurboMode.price = el.price
        }
      }
      if (!this.editTurboMode.isEdit) {
        this.turboModeItems.push(this.editTurboMode)
      }
      this.$refs.modalTurboModeDynamicShaping.hide()
    },
    async shown () {
      this.oneServices = []
      this.selected = 'durationRadio'
      this.days = 0
      this.hours = 0
      this.minutes = 0
      this.incomingUnlimited = false
      this.outgoingUnlimited = false
      if (this.editTurboMode.incoming_rate === '-1') {
        this.incomingUnlimited = true
        this.editTurboMode.incoming_rate = ''
      }
      if (this.editTurboMode.outgoing_rate === '-1') {
        this.outgoingUnlimited = true
        this.editTurboMode.outgoing_rate = ''
      }
      if (this.editTurboMode.incoming_limit > 0 || this.editTurboMode.outgoing_limit > 0) {
        this.selected = 'trafficValumeRadio'
      }
      if (this.editTurboMode.duration > 0) {
        this.days = Math.floor(this.editTurboMode.duration / 86400)
        this.hours = Math.floor((this.editTurboMode.duration - this.days * 86400) / 3600)
        this.minutes = Math.floor((this.editTurboMode.duration - (this.days * 86400) - (this.hours * 3600)) / 60)
      }

      for (let el of this.$store.getters['Tariffing/SERVICES']) {
        if (el.service_type === 1) {
          await this.$store.dispatch('Tariffing/GET_ONE_TIME_SERVICE', el.service_id).then(response => {
            let once = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ONE_TIME_SERVICE']))
            let newEl = {
              value: 0,
              text: '',
              price: 0
            }
            newEl.value = once.once_service_data.service_id
            newEl.text = once.service_data.service_name + '(' + once.once_service_data.service_id + ')' + this.$i18n.t(' Price: ') + once.once_service_data.cost
            newEl.price = once.once_service_data.cost
            this.oneServices.push(newEl)
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/dynamicShaping/turboMode.vue